/**
 * GeoManager — State Persistence
 *
 * LocalStorage backup/restore for offline resilience.
 */

import { state } from './state.js';

export function saveToLocalStorage() {
    if (!state.stateChanged) return;

    try {
        const currentHash = JSON.stringify({
            f: state.folders.length,
            p: state.points.length,
            ids: state.points.slice(0, 10).map(p => p.id).join(',')
        });

        if (currentHash === state.lastSavedStateHash) {
            state.stateChanged = false;
            return;
        }

        localStorage.setItem('geoManagerFolders', JSON.stringify(state.folders));
        localStorage.setItem('geoManagerPoints', JSON.stringify(state.points));

        state.lastSavedStateHash = currentHash;
        state.stateChanged = false;
    } catch (e) {
        console.warn('LocalStorage save failed:', e);
    }
}

export function loadFromLocalStorage() {
    try {
        const folders = localStorage.getItem('geoManagerFolders');
        const points = localStorage.getItem('geoManagerPoints');

        if (folders) state.folders = JSON.parse(folders);
        if (points) state.points = JSON.parse(points);
    } catch (e) {
        console.warn('LocalStorage load failed:', e);
    }
}
